
<template>
  <div>
    <v-dialog v-model="dialog" persistent width="600px">
      <v-card>
        <v-card-title>
          <span v-if="!loading">{{ !vrt_protest.id ? 'Criando protesto para fatura número' : 'Protesto fatura número' }} #{{ this.vrt_protest.vrt_transaction_id }}</span>
          <span v-if="loading">Carregando...</span>
          <v-spacer></v-spacer>
          <v-chip class="success" small v-if="vrt_protest.status == 'solved'">Solucionado</v-chip>
          <v-chip class="success" small v-if="vrt_protest.status == 'on_going'">Em andamento</v-chip>
        </v-card-title>
        <v-card-text class="pb-0">
          <card-loading-transparent v-if="loading || saving" :loadingText="loading ? 'Carregando' : 'Salvando'"></card-loading-transparent>
          <div v-if="!loading && !saving">
            <p class="my-0"><strong>Detalhes da fatura:</strong> {{ vrt_transaction.comment }}</p>
            <p class="my-0"><strong>Valor:</strong> {{ Number(vrt_transaction.ammount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
            <p class="my-0"><strong>Valor pago:</strong> {{ Number(vrt_transaction.ammount_payed).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
            <p class="my-0"><strong>Data de vencimento:</strong> {{ $moment(vrt_transaction.DateExpired).format('LL') }}</p>
            <p class="my-0"><strong v-if="vrt_transaction.payment_description">Descrição da fatura</strong> {{ vrt_transaction.payment_description }}</p>
            <p class="my-0"><strong v-if="vrt_protest.created_by">Protestado por:</strong> {{ vrt_protest.created_by }}</p>
            <p class="my-0"><strong v-if="vrt_protest.solved_by_user_name">Solucionado por:</strong> {{ vrt_protest.solved_by_user_name }}</p>
            
            <v-form ref="form" class="pt-6">
              <v-textarea label="Comentário do protesto" outlined v-model="vrt_protest.comment" :rules="required" :readonly="!!vrt_protest.id"></v-textarea>
              <v-textarea label="Comentário liberação do protesto" outlined v-model="vrt_protest.solved_comment" :rules="required" :readonly="vrt_protest.status == 'solved'" v-if="(vrt_protest.id) && canUpdate "></v-textarea>
            </v-form>
          
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn :disabled="loading || saving" save @click="saveVrtProtest" v-if="!vrt_protest.id && canCreate"></f-btn>
          <f-btn :disabled="loading || saving" save alt_text="Marcar como solucionado" @click="saveVrtProtest" v-if="vrt_protest.id && !loading && vrt_protest.status != 'solved' && canUpdate"></f-btn>
          <f-btn close @click="$router.go(-1)"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'ProtestVrtTransaction',
  mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,
      loading: false,
      saving: false,
      vrt_transaction: {},
      vrt_protest: {
        id: null,
        comment: '',
        vrt_transaction_id: this.vrt_transaction_id,
        user_id: null,
      },
    }
  },
  methods: {
    saveVrtProtest() {
      if(this.$refs.form.validate()){
        this.saving = true
        let METHOD = this.vrt_protest.id ? 'updateAsSolved' : 'create'
        if(METHOD == 'update'){
          this.vrt_protest.status = 'solved'
        }
        Api.VrtProtest[METHOD](this.vrt_protest).then(r=> {
          this.vrt_protest = r.data
          this.successSaved()
          if(METHOD == 'create') this.$router.go(-1);
        }).catch(err=> {
          if (err.response.data?.base[0]){
            this.addNotification({type: 'error', msg: err.response.data?.base[0]})
          }else{
            this.errorCreated()
          }
        }).finally(() => {
          this.saving = false
        })
      }
    },
    getVrtTransaction(){
      this.loading = true
      Api.VrtTransaction.show(this.vrt_protest.vrt_transaction_id).then((r) => {
        this.vrt_transaction = r.data.data.attributes
      }).catch(err=>{
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    getVrtProtest(){
      this.loading = true
      Api.VrtProtest.index({vrt_transaction_id: this.vrt_protest.vrt_transaction_id}).then(r=> {
        if(r.data.length > 0 ){
          this.vrt_protest = {...r.data.find(el=> el.vrt_transaction_id == this.vrt_protest.vrt_transaction_id)}
        }
      })
    },
    
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    canUpdate(){
      //this.
      return this.isSalesExecutive() || this.isDirector() || this.isCreditAnalyst();
    },
    canCreate(){
      return this.isAnalyst() || this.isDirector() || this.isCreditAnalyst();
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    // this.vrt_transaction_id = this.$route.params.protested_transaction_id ? this.$route.params.protested_transaction_id : this.$route.params.id
    this.vrt_protest.vrt_transaction_id = this.$route.params.protested_transaction_id ? this.$route.params.protested_transaction_id : this.$route.params.id
    this.getVrtTransaction();
    this.getVrtProtest();
  },
}
</script>

<style scoped>

</style>